<template>
  <v-app-bar clipped-left class="primary" app dark>
    <div class="d-flex align-center">
      <v-app-bar-nav-icon class="hidden-lg-and-up" @click="toggleDrawer()"></v-app-bar-nav-icon>
      <v-img
        alt="Logo Notarios"
        class="shrink mr-2"
        contain
        style="background-color:white;border-radius: 10%;"
        :src="require('@/assets/logo-notarios.png')"
        transition="scale-transition"
        width="40"
      />
      <h3>Notarios de Chihuahua</h3>
    </div>

    <!-- <v-spacer></v-spacer>
    <v-btn text v-if="isConnected" @click="signOut">Cerrar sesión</v-btn>
    <v-btn text v-else to="/inicio">Iniciar sesión</v-btn> -->

    <!-- <v-btn
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
        text
      >
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
    </v-btn>-->
  </v-app-bar>
</template>

<script>
import auth from "@/firebase/login";
export default {
  computed: {
    isConnected() {
      return this.$store.state.firUser != null;
    },
  },
  methods: {
    toggleDrawer() {
      console.log("togglig drawer")
      this.$emit("toggle");
    },
    signOut() {
      auth.signOut();
    },
  },
};
</script>

<style>
</style>